import request from '@/utils/request'


// 获取plus用户的积分
export function plusInfo() {
  return request({
    url: '/plus/info',
    method: 'get'
  })
}
// 获取plus用户宣传材料
export function plusMaterials() {
  return request({
    url: '/plus/downloadMaterial',
    method: 'get'
  })
}

// ddd
export function plussPoint() {
  return request({
    url: '/plus/plusPointPdf',
    method: 'get'
  })
 }
 // plus页面 Plus推荐资源
 export function plusResource(data) {
   return request({
     url: `/plus/resource?pageNum=${data.pageNum}&size=${data.pageSize}`,
     method: 'get'
   })
 }
 